import { square_values_community, square_values_freedom, square_values_growth, square_values_knowledge, square_values_sustainability } from "../assets/updated_assests/assets";

export const missionData = [
    {
        image: square_values_sustainability,
        title: 'Sustainability',
        description: 'Protect nature, nurture the planet, always.'
    },
    {
        image: square_values_growth,
        title: 'Growth',
        description: 'Discover, learn and Inspire through every journey'
    },
    {
        image: square_values_freedom,
        title: 'Freedom',
        description: 'Embrace adventure with adaptability and purpose'
    },
    {
        image: square_values_community,
        title: 'Community',
        description: 'Build Connections that Empower and uplift everyone'
    },
    {
        image: square_values_knowledge,
        title: 'Knowledge',
        description: 'Share Insights that guide and transform lives'
    },
]